import styled from 'styled-components/macro';
import media from '../../styles/media';
import { fontSize } from '../../styles/mixins';

export const TwoOptionButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
`;
const baseButton = styled.button`
  background: ${({ selected, theme }) =>
    selected ? theme.buttonBgColorInverseLight : theme.buttonBgColorLight};
  border: 1px solid
    ${({ selected, invalid, theme }) =>
      (invalid && theme.invalidColor) ||
      (selected && theme.buttonBorderColor) ||
      theme.buttonBorderColor};
  color: ${({ selected, invalid, theme }) =>
    (invalid && theme.invalidColor) ||
    (selected && theme.colorText) ||
    theme.buttonTextColor};
  flex-grow: 1;
  flex-basis: 100px;
  font-weight: 500;
  max-width: 160px;
  ${fontSize(14)};
  height: 40px;
  ${media.desktop`
    height: 50px;
  `};
  cursor: pointer;
  &:hover {
    border-color: ${({ theme }) => theme.buttonBgHover};
    color: ${({ theme }) => theme.buttonBgHover};
  }
`;
export const ButtonLeft = styled(baseButton)`
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  border-right: 0;
`;
export const ButtonRight = styled(baseButton)`
  border-top-right-radius: 100px;
  border-bottom-right-radius: 100px;
`;
